import { WorkflowArea } from '../enums/workflow-area.enum';

export interface SyncWorkflowRequestDto {
  workflowArea: WorkflowArea;
  sync: boolean;
}